<template>
    <div class="mask" @click.stop="() => null" v-show="visible">
        <div class="board_container" :style="{ height: enableEvent ? '380px' : '200px' }" @keydown.stop="() => false">
            <div class="head"><span>标注</span> <i @click.stop="visible = false" class="iconfont iconguanbi"></i></div>
            <div>
                <div class="section section_1">
                    <span class="label">内容</span>
                    <div>
                        <el-input type="textarea" :rows="2" maxlength="20" placeholder="请输入标注内容" v-model="billboardInfo.input"  resize="none"></el-input>
                        <!-- <el-checkbox v-model="billboardInfo.effect">大小随视角变化</el-checkbox> -->
                    </div>
                </div>
                <div class="section section_2">
                    <span class="label">事件关联</span>
                    <el-switch v-model="enableEvent" @change="filename = ''; billboardInfo.data.content = '';" active-color="#1458EA"></el-switch>
                </div>
                <div class="section section_3" v-show="enableEvent">
                    <div class="row">
                        <span class="label">关联类型</span>
                        <el-select v-model="billboardInfo.data.eventType" @change="eventTypeChange" placeholder="请选择">
                            <el-option
                                v-for="item in eventTypes"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select> 
                    </div>
                    <div class="row">
                        <span class="label">触发方式</span>
                        <p>鼠标左键单击</p>
                    </div>
                    <div class="row">
                        <span v-if="billboardInfo.data.eventType == 3" class="label">URL</span>
                        <span v-else class="label">选择文档</span>

                        <input v-if="billboardInfo.data.eventType == 3" :value="url" @input="changeUrl" type="text"/>
                        <button @click.stop="upload" v-if="billboardInfo.data.eventType != 3">{{ filename || '点击上传' }}</button>

                        <p v-if="billboardInfo.data.eventType == 0">(仅支持PDF格式、不超过10M)</p>
                        <p v-if="billboardInfo.data.eventType == 1">(仅支持.png/.jpg/.jpeg格式，不超过2M)</p>
                        <p v-if="billboardInfo.data.eventType == 2">(仅支持.mp4格式，不超过10M)</p>
                        
                    </div>
                </div>
                <div class="section srction_4">
                    <el-button @click.stop="toDelete">删除</el-button>
                    <el-button type="primary" @click.stop="confirm">确认</el-button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import uuid from 'uuidjs'
export default {
    data(){
        return {
            visible: false,
            boardInfo: {
                enableBoard: false,
                list: [],
                pageNo: 1
            },
            enableEvent: false,
            billboardInfo: {
                id: '',
                mid: '',
                input: '',
                position: [],
                effect: true,
                data: {
                    eventType: 0,
                    content: ''
                }
            },
            eventTypes: [
                { name: '文档', value: 0 },
                { name: '图片', value: 1 },
                { name: '视频', value: 2 },
                { name: '网页', value: 3 }
            ],
            filename: '',
            url: ''
        }
    },

    computed: {
        viewer(){
            return window.viewer
        },
        billBoard(){
            return window.billBoard
        }
    },

    mounted(){
        this.billBoard.dblclickSelectHandler = object => {
            var { id, mid, position, text, data } = object.userData
            if( data && data.content ){
                this.enableEvent = true
            }else{
                data = {
                    eventType: 0,
                    content: '' 
                }
                this.enableEvent = false
            }
            this.billboardInfo = {
                id,
                input: text,
                position: position,
                mid,
                data
            }
            if( data.eventType == 3 ){
                this.url = data.content
            }
            this.filename = '点击替换'
            this.visible = true
        }
    },

    methods: {
        /**
         * 初始化
         */
        init( event ){
            this.viewer.picker.intersectModels(event, intersects => {
                intersects = intersects.filter( item => {
                    return item.object.type == 'Mesh' || item.object.type == 'Object3D'
                } )
                var object, intersect = intersects[ 0 ]
                if ( intersects.length > 0 ) {
                    object = AMRT.Utils.getModelNode( intersect.object )
                }
                if( object ){
                    if( !object.mid ){
                        return this.$message.warning('该模型不支持添加标注')
                    }
                    var position = object.worldToLocal( intersect.point )
                    this.billboardInfo = {
                        id: '',
                        input: '',
                        position: position.toArray(),
                        mid: object.mid,
                        data: {
                            eventType: 0,
                            content: ''
                        }
                    }
                    this.filename = ''
                    this.url = ''
                    this.enableEvent = false
                    this.visible = true
                }
            }, this, this.viewer.gisGroup.children )
        },

        /**
         * 确认编辑
         */
        confirm(){
            if( !this.billboardInfo.input ){
                this.$message.warning('标注内容不能为空!')
                return
            }
            if( this.enableEvent && !this.billboardInfo.data.content ){
                this.$message.warning('请绑定事件信息')
                return
            }
            //编辑模式
            if( this.billboardInfo.id ){
                let child = this.billBoard.group.children.find(item => item.userData.id == this.billboardInfo.id )
                this.billBoard.remove( child )
            }
            var obj = {
                id: this.billboardInfo.id || uuid.genV4().toString(),
                mid: this.billboardInfo.mid,
                position: this.billboardInfo.position,
                text: this.billboardInfo.input,
                data: null
            }
            if( this.enableEvent ){
                obj.data = this.billboardInfo.data
            }
            this.billBoard.add( obj, () => {
                this.$message.success('操作成功')
                this.visible = false
            })
        },

        /**
         * 上传 文件/图片/视频
         */
        upload(){
            var type
            switch ( this.billboardInfo.data.eventType ) {
                case 0:
                    type = 'file'
                    break;
                case 1:
                    type = 'image'
                    break
                case 2:
                    type = 'video'
                    break
            }
            this.$util.uploadOBS( type ).then(res => {
                this.filename = res.file.name
                this.billboardInfo.data.content = res.url
            })
        },

        /**
         * 修改事件类型
         */
        eventTypeChange(){
            this.billboardInfo.data.content = ''
            this.filename = ''
        },

        changeUrl(e){
            this.url = e.target.value
            this.billboardInfo.data.content = e.target.value
        },

        toDelete(){
            if( this.billboardInfo.id ){
                let child = this.billBoard.group.children.find(item => item.userData.id == this.billboardInfo.id )
                this.billBoard.remove( child )
                this.visible = false
            }else{
                this.visible = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mask{ width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index: 9; background-color: rgba(0, 0, 0, 0.5); }
.board_container{
    position: absolute; z-index: 9; width: 350px; height: 400px; background-color: #F2F4F6; padding: 20px; border-radius: 5px; overflow: hidden; top: 400px; right: 420px;
    .head{ 
        background-color: #1458EA; width: 100%; height: 34px; display: flex; justify-content: space-between; padding: 0 20px; align-items: center; margin: -20px 0 0 -20px; font-size: 14px; color: #FFF;
        .iconfont{cursor: pointer; font-size: 14px; &:hover{transform: scale(1.2); transition: 1s transform;}}
    }
    .section{
        display: flex; padding: 15px 0;
        .label{display: inline-block; width: 20%; color: #182C49; opacity: 0.7; text-align: right; margin-right: 10px; font-size: 14px;}
        /deep/ .is-checked .el-checkbox__inner{
            background-color: #1458EA;
            border-color: #1458EA;
        }
        /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{ color: #182C49; }
        /deep/ .el-textarea{
            .el-textarea__inner{border: none;}
            border: none; margin-bottom: 10px;
        }
    }
    .section_1{
        >div{width: 80%;}
    }
    .section_2{
        border-bottom: 1px solid #E0E2E3; display: flex; justify-content: space-between; padding: 0 0 10px 0;
        .label{opacity: 1.0;}
    }
    .section_3{
        flex-direction: column; 
        .row{ 
            display: flex; align-items: center; margin: 10px 0; font-size: 14px;
            .label{display: inline-block; width: 20%; color: #182C49; opacity: 0.7; font-size: 14px;}
            p{color: #182C49; opacity: 0.7; }
            input{ width: 240px; height: 34px; line-height: 34px; padding: 0 10px; }
            /deep/ .el-select{ width: 77%; }
        }
        .row:nth-last-child(1){
            position: relative; height: 34px;
            button{font-size: 14px; color: #1458EA; background-color: transparent; text-decoration: underline; cursor: pointer;width: 65%; overflow: hidden; text-overflow: ellipsis; text-align: left;}
            p{color: #182C49; opacity: 0.7; position: absolute; top: 24px; left: 80px; font-size: 12px;margin-top: 5px;}
        }
    }
    .srction_4{
        justify-content: center; margin-top: 5px;
        /deep/ .el-button{
            width: 140px; height: 34px; border-radius: 17px;
            span{
                position: relative; top: -2px;
            }
        }
        /deep/ .el-button--primary{
            background-color: #1458EA; border-color: #1458EA;
        }
    }
}
</style>